import { render, staticRenderFns } from "./CargoKanbanCardCargo.vue?vue&type=template&id=0c3e1831&scoped=true"
import script from "./CargoKanbanCardCargo.vue?vue&type=script&lang=js"
export * from "./CargoKanbanCardCargo.vue?vue&type=script&lang=js"
import style0 from "./CargoKanbanCardCargo.vue?vue&type=style&index=0&id=0c3e1831&prod&lang=css"
import style1 from "./CargoKanbanCardCargo.vue?vue&type=style&index=1&id=0c3e1831&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3e1831",
  null
  
)

export default component.exports